/**
 * Product category constants
 */
export const F_AND_B_EQUIPMENT_CATEGORY = 'F&B EQUIPMENT';

/**
 * WhatsApp contact for F&B Equipment inquiries
 * Priority: EQUIPMENT_WA_NUMBER env variable, fallback to hardcoded value
 */
export const F_AND_B_EQUIPMENT_WHATSAPP_NUMBER =
  process.env['NEXT_PUBLIC_EQUIPMENT_WA_NUMBER'] || '6282122338586';

/**
 * Default fallback for outlet name when not available
 */
export const DEFAULT_OUTLET_NAME_FALLBACK = '[isi nama outlet]';

/**
 * Check if a product category is F&B Equipment (case-insensitive)
 * @param categoryName - Product category name
 * @returns true if product is F&B Equipment
 */
export const isFnBEquipmentCategory = (
  categoryName: string | undefined | null
): boolean => {
  return (
    categoryName?.toUpperCase() === F_AND_B_EQUIPMENT_CATEGORY.toUpperCase()
  );
};

/**
 * Generates WhatsApp URL with prefilled message for F&B Equipment inquiries
 * @param itemCode - Product item code
 * @param brandDesc - Brand description
 * @param productName - Product name/description
 * @param outletName - Outlet name for the message
 * @returns WhatsApp URL with encoded message
 */
export const generateFnBEquipmentWhatsAppUrl = (
  itemCode: string | number,
  brandDesc: string,
  productName: string,
  outletName: string
): string => {
  const message = `Hai, Admin equipment Sukanda Djaya, saya dari ${outletName} ingin bertanya terkait produk (${itemCode}) ${brandDesc} - ${productName}`;
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${F_AND_B_EQUIPMENT_WHATSAPP_NUMBER}?text=${encodedMessage}`;
};
